import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimplesaudartomumbaicabservice() {



const cardData = {
  keyword: " Pimple Saudagar to Mumbai Cab Service  ",

"headingDescription": "SRS Cab Service offers Pimple Saudagar to Mumbai Cab Service, providing a safe, comfortable, and reliable travel solution for daily commuters, business travelers, and tourists. Our well-maintained vehicles, professional drivers, and timely pickups ensure a smooth journey from Pimple Saudagar to Mumbai. Ideal for airport transfers, corporate trips, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is Mumbai’s iconic landmark overlooking the Arabian Sea. Travelers using Pimple Saudagar to Mumbai Cab Service from SRS Cab Service often visit this site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a scenic promenade famous for sunset views and city skyline. Visitors using SRS Cab Service often enjoy leisurely walks and coastal views."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves on an island near Mumbai. Travelers using SRS Cab Service often include this destination for historical and cultural exploration."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station is renowned for its Victorian Gothic architecture. Visitors using SRS Cab Service often admire its grandeur and heritage significance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a popular Mumbai coastal destination known for street food and leisure activities. Travelers using SRS Cab Service often visit to enjoy sunset views and local cuisine."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a famous temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque located on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for spiritual significance and scenic beauty."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant shopping and cultural street in Mumbai. Travelers using SRS Cab Service often explore this area for shopping, dining, and local experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green space offering wildlife and trekking activities. Visitors using SRS Cab Service often enjoy nature and outdoor recreation here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting major areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Pimple Saudagar to Mumbai Cab",
description: "Pimple Saudagar to Mumbai cab offers reliable intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pimple Saudagar to Mumbai Airport Cab",
description: "Pimple Saudagar to Mumbai airport cab provides convenient airport transfer services. Customers can book cabs for timely drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pimple Saudagar to Mumbai International Airport",
description: "Pimple Saudagar to Mumbai international airport cab offers premium transfer for passengers. Customers can book cabs for smooth airport journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pimple Gurav to Mumbai Cab Service",
description: "Pimple Gurav to Mumbai cab service provides reliable travel for long-distance journeys. Customers can book cabs for flexible trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Pimple Gurav",
description: "Taxi service in Pimple Gurav offers dependable transportation for local and outstation travel. Customers can book taxis for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Taxi Service in Pimple Saudagar Pune",
description: "Taxi service in Pimple Saudagar Pune provides reliable travel for local and intercity trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab offers reliable transfer services for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab provides spacious and comfortable SUV travel. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Top-rated Mumbai to Pimple Saudagar Cabs",
description: "Top-rated Mumbai to Pimple Saudagar cabs offer reliable return travel services. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with top-rated cab services."
},
{
name: "Pimple Saudagar to Dadar Cab Service",
description: "Pimple Saudagar to Dadar cab service provides convenient travel for central Mumbai routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pimple Gurav to Dadar Cab Service",
description: "Pimple Gurav to Dadar cab service offers reliable transportation for city travel. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Pimple Gurav",
description: "Cab service in Pimple Gurav provides dependable transportation for local and outstation trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Innova Crysta on Rent in Pimple Saudagar Pune",
description: "Innova Crysta on rent in Pimple Saudagar Pune offers premium SUV travel for comfort. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Pimple Saudagar to Andheri Cab",
description: "Pimple Saudagar to Andheri cab offers reliable travel for business and airport routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip provides convenient two-way travel options. Customers can book cabs for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Ertiga on Rent in Pimple Saudagar",
description: "Ertiga on rent in Pimple Saudagar offers comfortable 7 seater travel for families. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for city and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab offers dependable intercity transportation for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service Pimple Saudagar Pune",
description: "Cab service Pimple Saudagar Pune provides reliable local and outstation travel options. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
}
],

tableData: [
["Pimple Saudagar to Mumbai Cab","Pimple Saudagar to Mumbai Airport Cab"],
["Pimple Saudagar to Mumbai International Airport","Pimple Gurav to Mumbai Cab Service"],
["Taxi Service in Pimple Gurav","Taxi Service in Pimple Saudagar Pune"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Top-rated Mumbai to Pimple Saudagar Cabs"],
["Pimple Saudagar to Dadar Cab Service","Pimple Gurav to Dadar Cab Service"],
["Cab Service in Pimple Gurav","Innova Crysta on Rent in Pimple Saudagar Pune"],
["Pimple Saudagar to Andheri Cab","Pune to Mumbai Cab Round Trip"],
["Ertiga on Rent in Pimple Saudagar","Cab Service in Pune"],
["Pune Mumbai Cab","Cab Service Pimple Saudagar Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Quick Pickup from Pimple Saudagar Area",
    WhyChoosedescription: "SRS Cab Service provides fast pickup from Pimple Saudagar, Rahatani, Aundh, Wakad, and nearby areas for smooth travel to Mumbai."
  },
  {
    WhyChooseheading: "Affordable Pimple Saudagar to Mumbai Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly cab services from Pimple Saudagar to Mumbai with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-experienced on the Mumbai-Pune Expressway, ensuring safe, fast, and comfortable travel."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pimple Saudagar to Mumbai cab bookings, ideal for airport transfers, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and relaxing journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, and same-day return options based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and groups."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted for Pimple Saudagar to Mumbai cab bookings due to punctual service, professional drivers, and affordable pricing."
  }
]
}

const faqData = [
  { question: "Do you provide Pimple Saudagar to Mumbai cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pimple Saudagar to Mumbai." },
  { question: "How far is Mumbai from Pimple Saudagar?", answer: "The distance is approximately 150 km and takes around 3 to 4 hours via expressway." },
  { question: "What is the starting cab fare?", answer: "Cab fares typically start from ₹1800–₹2500 for sedan depending on availability and timing." },
  { question: "Is one-way cab available?", answer: "Yes, one-way cab services are available and are more affordable than round-trip bookings." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book Pimple Saudagar to Mumbai cab service online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, offices, and societies in Pimple Saudagar." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Patil",
    feedback:
      "Booked cab from Pimple Saudagar to Mumbai Airport. Very smooth journey and on-time pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Deshmukh",
    feedback:
      "Best cab service from Pimple Saudagar to Mumbai. Clean car and professional driver.",
    rating: 5
  }
];

























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pimple Saudagar to Mumbai Cab Service | SRS Cab Service",
  "description": "Book Pimple Saudagar to Mumbai cabs including airport transfers, one-way or round-trip taxi service. Innova, Ertiga, and Sedan available. 24x7 online booking.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pimple Saudagar",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411027",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5680",
    "longitude": "73.7930"
  },
  "url": "https://www.srscabservice.com/pimple-saudagar-to-mumbai-cabs",
  "areaServed": ["Pimple Saudagar", "Pimple Gurav", "Mumbai", "Mumbai Airport", "International Airport"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Pimple Saudagar to Mumbai Cab",
    "Pimple Saudagar to Mumbai Airport Cab",
    "Pimple Gurav to Mumbai Cab",
    "One-way Taxi from Pimple Saudagar to Mumbai",
    "Round-trip Taxi from Pimple Saudagar to Mumbai",
    "Innova, Ertiga, Sedan Cabs"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "850"
  }
};








  return (
    <div>
      <Helmet>
  <title>Pimple Saudagar to Mumbai Cab Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book Pimple Saudagar to Mumbai cabs at affordable fares. One-way or round-trip taxi service including airport transfers. Innova, Ertiga, and Sedan available. 24x7 online booking."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimplesaudartomumbaicabservice;